import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { faqs } from "../data/mock";
import "../styles/FAQ.css";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section section-padding-small">
      <div className="container">
        <div className="faq-header">
          <h2 className="hero-medium">Frequently Asked Questions</h2>
          <p className="body-large">
            Everything you need to know about our treatments and services
          </p>
        </div>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={faq.id} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <span className="heading-3">{faq.question}</span>
                <ChevronDown className={`faq-icon ${openIndex === index ? "rotate" : ""}`} />
              </button>
              <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
                <p className="body-regular">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
